import { render, staticRenderFns } from "./tagsToOrder.vue?vue&type=template&id=5c77b0a3&"
import script from "./tagsToOrder.vue?vue&type=script&lang=js&"
export * from "./tagsToOrder.vue?vue&type=script&lang=js&"
import style0 from "./tagsToOrder.vue?vue&type=style&index=0&id=5c77b0a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports